import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { IRoleModel, IStatusModel } from '@shared/interfaces/simple-ui.interface';

export const rolesList: Array<IRoleModel> = [
  { name: marker('Admin'), value: 'admin' },
  { name: marker('Manager'), value: 'manager' },
  { name: marker('Employee'), value: 'worker' }
];

export const statusList: Array<IStatusModel> = [
  { name: marker('Active'), value: 'active' },
  { name: marker('Inactive'), value: 'inactive' }
];

export enum PaymentPlan {
  Trial = 'Trial',
  Free = 'Free',
  Regular = 'Regular'
}

marker('Trial');
marker('Free');
marker('Regular');

export enum ImportModule {
  client = 'Clients',
  project = 'Project',
  material = 'Material'
}

marker('Clients');
marker('Project');
marker('Material');

export const emailUnitPattern =
  /^[a-zA-ZøåæÅØÆåöäÅÖÄüöäÜÖÄ0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-ZøåæÅØÆåöäÅÖÄüöäÜÖÄ0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-ZøåæÅØÆåöäÅÖÄüöäÜÖÄ0-9](?:[a-zA-ZøåæÅØÆåöäÅÖÄüöäÜÖÄ0-9-]*[a-zA-ZøåæÅØÆåöäÅÖÄüöäÜÖÄ0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

export const emailPattern = new RegExp(
  [
    "^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+",
    "(?:\\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*",
    '@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)',
    '+[a-zA-Z]{2,}$'
  ].join('')
);
export const passwordPattern = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;

export enum KeyCodes {
  AltRight = 'AltRight',
  AltLeft = 'AltLeft'
}

export const TaxTypesList = [
  {
    name: '25',
    key: 25
  },
  {
    name: '19',
    key: 19
  },
  {
    name: '15',
    key: 15
  },
  {
    name: '12',
    key: 12
  },
  {
    name: '7',
    key: 7
  }
];
